/** Shared branch → Firestore collection name candidates (same as Flutter AttendanceBranchCatalog). */
export const ATTENDANCE_BRANCHES = [
  {
    label: "Main Shop",
    punchCandidates: [
      "Wins Attendance",
      "wins attendance",
      "WinsAttendance",
      "attendance",
      "Attendance",
    ],
    employeeCandidates: ["Employees", "employees"],
  },
  {
    label: "Spareway",
    punchCandidates: [
      "Spareway Attendance",
      "spareway attendance",
      "attendance1",
      "Attendance1",
    ],
    employeeCandidates: ["Employees1", "employees1"],
  },
  {
    label: "Branch 3",
    punchCandidates: [
      "Branch Attendance",
      "BranchAttendance",
      "branch attendance",
      "branch_attendance",
      "attendance3",
      "Attendance3",
    ],
    employeeCandidates: ["Employees3", "employees3"],
  },
];

export function branchRowForLabel(label) {
  const b = ATTENDANCE_BRANCHES.find((x) => x.label === label);
  return b || ATTENDANCE_BRANCHES[0];
}

/** Flutter uses string ISO queries for these punch collections. */
export function usesStringIsoTimestamp(collectionName) {
  if (!collectionName) return false;
  const n = String(collectionName).toLowerCase().replace(/\s+/g, "");
  return (
    n.includes("branchattendance") ||
    n.includes("winsattendance") ||
    n.includes("sparewayattendance") ||
    n === "attendance" ||
    n === "attendance1"
  );
}
